/**
 * Use instead of `map.removeObject` in hook cleanups: React tears effects down parent first, so
 * `useMap` has already disposed the map and detached the object, and removing it then throws.
 */
export const safeRemoveObject = (map: H.Map, object: H.map.Object): void => {
  if (object.getParentGroup() !== null) {
    map.removeObject(object)
  }
}
